import { useEffect } from "react";

import { useTicketsUnreadCount } from "@/features/tickets";
import { useSession } from "@/shared/model/session";
import { useUnread } from "@/shared/model/use-unread";

/**
 * Syncs unread tickets count from features layer to shared context
 * This hook should be called at app level to bridge the FSD layers
 */
export function useSyncUnread() {
  const { isAuthenticated } = useSession();
  const ticketsUnread = useTicketsUnreadCount();
  const { setTicketsUnread } = useUnread();

  useEffect(() => {
    setTicketsUnread(isAuthenticated ? ticketsUnread : 0);
  }, [ticketsUnread, isAuthenticated, setTicketsUnread]);
}
